var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.fields)?_c('div',{staticClass:"item"},[_vm._l((_vm.schema),function(field,fieldName){return _c('form-row',{key:fieldName,staticClass:"language-item",attrs:{"rules":_vm.rules[`${_vm.item.id}__${fieldName}`],"prop":`${_vm.item.id}__${fieldName}`,"field":{
      ...field,
      name: `${_vm.item.id}__${fieldName}`,
      visibility: _vm.disabled ? 'disabled' : '',
      placeholder: 'Не выбрано',
      visual_value: {
        id: _vm.getField(field?.id_name?.name).value,
        name: _vm.getField(fieldName).value
      },
      value: _vm.getField(fieldName).value,
      id_name: {
        ...field?.id_name,
        value: _vm.getField(field?.id_name?.name).value
      }
    },"options":[
      {
        id: _vm.getField(field?.id_name?.name).value,
        name: _vm.getField(fieldName).value
      }
    ],"form":_vm.parentForm,"model":_vm.getField(fieldName).value,"noRequiredStar":true},on:{"set-value":(name, val) =>
        _vm.handleChange({
          [`${_vm.item.id}__${fieldName}`]: val
        }),"change-option":_vm.changeOption}})}),_c('Button',{staticClass:"delete-button",attrs:{"buttonColor":"transparent","buttonText":"","iconName":"delete","hasLeftIcon":"","iconColor":"#CDD4DA","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return (() => _vm.handleChange()).apply(null, arguments)}}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }